
import Skills from './Skills';
import Intro from './Intro';
import Experience from './Experience';
import Education from './Education';
import AiAssistantSection from '../../components/portfolio/ai-assistant/AiAssistantSection';

function About() {
   return (
      <>
         <section className="hero-ai-layout">
            <Intro/>
            <AiAssistantSection/>
         </section>
         <Skills/>
         <Experience/>
         <Education/>
      </>
   );
}
export default About;
